import type { SVGProps } from 'react';
const SvgSailboat = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" {...props}>
    <path d="M284.6 6.2C280.4.8 273.2-1.3 266.8.9S256 9.2 256 16v288c0 8.8 7.2 16 16 16h224c6.1 0 11.7-3.5 14.4-9s2-12-1.7-16.9l-224-288zm-72 90.5c-6.7-2-14 .6-17.9 6.4l-128 192c-3.3 4.9-3.6 11.2-.8 16.4S74.1 320 80 320h128c8.8 0 16-7.2 16-16V112c0-7.1-4.6-13.3-11.4-15.3M60 400h456l-.4 1.6c-8.2 36.5-40.6 62.4-78 62.4H138.4c-37.4 0-69.8-25.9-78-62.4zm-40-48c-10.3 0-17.9 9.5-15.6 19.5l9.1 40.6c13.1 58.4 65 99.9 124.9 99.9h299.2c59.9 0 111.7-41.5 124.9-99.9l9.1-40.6c2.2-10-5.4-19.5-15.6-19.5z" />
  </svg>
);
export default SvgSailboat;
